import angular from 'angular';
import { replace } from 'lodash';

module.exports = angular.module('market.routes.dashboard', [
  require('angular-ui-router'),
  require('../../models/work-order'),
])
.config(function($stateProvider) {
  $stateProvider.state('dashboard', {
    parent: 'root',
    url: '/dashboard',
    abstract: true,
    template: '<div ui-view></div>',
  });

  $stateProvider.state('dashboard.work_order', {
    url: '/work-orders/:referenceNumber',
    resolve: {
      workOrder: function babelWorkOrderResolve(WorkOrder, $stateParams) {
        return WorkOrder
          .get({ reference_number: $stateParams.referenceNumber })
          .$promise
          .catch(function() { return undefined; });
      }
    },
    views: {
      'header@': {
        template: '<div></div>' // disable the header
      },
      'footer@': {
        template: '<div></div>' // disable the footer
      },
      '': {
        templateUrl: '/templates/market/dashboard/work_orders/show.html',
        controllerAs: 'work_order_ctrl',
        controller: class {
          constructor($scope, workOrder) {
            this.workOrder = workOrder;
            this.vendor = this.workOrder ? this.workOrder.vendor : null;
          }

          displayDescription(item) {
            let desc = item.public_description || item.revised_description || item.description;
            return replace(desc, item.label + ':', '');
          }
        }
      }
    }
  });

  $stateProvider.state('dashboard.work_orders_for_home_condition_report', {
    url: '/work_orders_for_home_condition_report/:hcr_id',
    views: {
      'header@': {
        template: '<div></div>' // disable the header
      },
      'footer@': {
        template: '<div></div>' // disable the footer
      },
      '': {
        templateUrl: '/templates/market/dashboard/work_orders/for_home_condition_report.html',
        controllerAs: 'work_order_hcr_ctrl',
        controller: class {
          constructor($scope,  $stateParams, WorkOrder) {
            this.workOrders = WorkOrder.for_home_condition_report({ hcr_id: $stateParams.hcr_id });
          }

          displayDescription(item) {
            let desc = item.public_description || item.revised_description || item.description;
            return replace(desc, item.label + ':', '');
          }
        }
      }
    }
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/dashboard/index.js
 **/